import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = unauth, obj = auth
  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("isteform_token", data.token);
    setUser(data);
    return data;
  }, []);
  const register = useCallback(async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    if (data.token) localStorage.setItem("isteform_token", data.token);
    setUser(data);
    return data;
  }, []);
  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.error("Errore logout:", e); }
    localStorage.removeItem("isteform_token");
    setUser(false);
  }, []);
  const value = useMemo(() => ({ user, setUser, login, register, logout }), [user, login, register, logout]);
  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
